import React from 'react';
import PropTypes from 'prop-types';
import styles from './validation_message.css';

/**
 * renders the SimpleValidationMessage component
 * @param {String} validationMessage the validation message
 * @returns {Node|Null} returns teh validation message component if validation message exists
 */
const SimpleValidationMessage = ({ validationMessage }) => {
    if (!validationMessage) {
        return null;
    }
    return (
        <div className={styles.validation_message}>
            <span className={styles.error}>
                {validationMessage}
            </span>
        </div>
    );
};

SimpleValidationMessage.propTypes = {
    validationMessage: PropTypes.string
};

export { SimpleValidationMessage };
